import React from 'react';
import { observer } from 'mobx-react';
import LastNotificationPreview from './LastNotificationPreview';
import { isAndroid, isChrome } from 'react-device-detect';

import { RootStoreContext } from '../../context';

@observer
class Notifications extends React.Component {

  static contextType = RootStoreContext;

  state = {
    desktopNotifications: false
  }

  async componentDidMount () {
    if ('Notification' in window && !(isAndroid && isChrome)) {
      if (Notification.permission === 'granted') {
        this.setState({ desktopNotifications: true });
      } else if (Notification.permission === 'default' && window.location.pathname !== '/') {
        const status = await Notification.requestPermission();
        if (status === 'granted') {
          this.setState({ desktopNotifications: true });
        }
      }
    }
  }

  dismissLastNotification = () => {
    this.context.uiStore.dismissLastNotification();
  }

  render () {
    const { uiStore: { notificationsDerivation } } = this.context;
    const { visible, data } = notificationsDerivation;
    const { desktopNotifications } = this.state;
    return visible && (
      <LastNotificationPreview
        notification={data[data.length - 1]}
        dismiss={this.dismissLastNotification}
        desktopNotifications={desktopNotifications}
      />
    );
  }
}

export default Notifications;